import { useState, useMemo, useEffect, useRef } from 'react';
import './Dashboard.css';

/**
 * props:
 * - symbol
 */
function CandleChart(props) {

    // eslint-disable-next-line
    const [widget, setWidget] = useState({});
    const containerRef = useRef(null);

    useEffect(() => {
        // Limpar widget anterior se existir
        const container = document.getElementById("tradingview_d34df");
        if (container) {
            container.innerHTML = '';
        }
        
        // Pequeno delay para garantir que o DOM está pronto
        const initTimer = setTimeout(() => {
            const w = new window.TradingView.widget({
                symbol: "BINANCE:" + props.symbol,
                autosize: true,
                interval: "1",
                timezone: "Etc/UTC",
                theme: "dark",
                style: "1",
                locale: "en",
                toolbar_bg: "#f1f3f6",
                enable_publishing: false,
                allow_symbol_change: true,
                details: true,
                withdateranges: true,
                hide_side_toolbar: false,
                studies: [
                    "RSI@tv-basicstudies"
                ],
                container_id: "tradingview_d34df",
                width: "100%",
                height: "100%"
            });
            setWidget(w);
        }, 100);
        
        return () => {
            clearTimeout(initTimer);
        };
    }, [props.symbol])

    const widgetHtml = useMemo(() => {
        return (
            <div className="row">
                <div className="col-12 mb-4">
                    <div className="card cardDark border-0 shadow candle-chart-container">
                        <div className="card-body p-0">
                            <div className="tradingview-widget-container" ref={containerRef}>
                                <div id="tradingview_d34df" className="divTradingView"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }, [props.symbol])

    return widgetHtml;
}

export default CandleChart;